import { render, staticRenderFns } from "./ListBottomMenu.vue?vue&type=template&id=2cb72db7&scoped=true&lang=html&"
import script from "./ListBottomMenu.vue?vue&type=script&lang=js&"
export * from "./ListBottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./ListBottomMenu.vue?vue&type=style&index=0&id=2cb72db7&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb72db7",
  null
  
)

export default component.exports